import PackageJSON from '../package.json';

const APP_VERSION = PackageJSON.version;

export default APP_VERSION;
